import { ApiResponse } from "../models/api.model";
import { User } from "../models/auth.model";

import axios from "./axios";

export default {
  getUsers(search?: string) {
    return axios.get().get<ApiResponse<User>>("/user/search", { params: { search } });
  }
};
